import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "./AppShell";
import { LoadingState } from "@/components/ui";
import { StagingAuthGate } from "@/features/auth/StagingAuthGate";

const DashboardPage = lazy(() => import("@/features/dashboard/DashboardPage"));
const ProjectsPage = lazy(() => import("@/features/projects/ProjectsPage"));
const CreateProjectPage = lazy(() => import("@/features/projects/CreateProjectPage"));
const ProjectPage = lazy(() => import("@/features/projects/ProjectPage"));
const LeadPage = lazy(() => import("@/features/leads/LeadPage"));
const WorkersPage = lazy(() => import("@/features/workers/WorkersPage"));

function Deferred({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingState label="در حال آماده‌سازی صفحه…" />}>{children}</Suspense>;
}

export default function App() {
  return <StagingAuthGate><Routes>
    <Route path="/" element={<Navigate to="/leads" replace />} />
    <Route path="/leads" element={<AppShell />}>
      <Route index element={<Deferred><DashboardPage /></Deferred>} />
      <Route path="projects" element={<Deferred><ProjectsPage /></Deferred>} />
      <Route path="projects/new" element={<Deferred><CreateProjectPage /></Deferred>} />
      <Route path="projects/:projectId" element={<Deferred><ProjectPage /></Deferred>} />
      <Route path="projects/:projectId/:tab" element={<Deferred><ProjectPage /></Deferred>} />
      <Route path="records/:leadId" element={<Deferred><LeadPage /></Deferred>} />
      <Route path="workers" element={<Deferred><WorkersPage /></Deferred>} />
    </Route>
    <Route path="*" element={<Navigate to="/leads" replace />} />
  </Routes></StagingAuthGate>;
}
